/* Keeps the CPFS header cart-icon count in sync after an add-to-cart, since the
   custom header is not one of Dawn's cart-rendered sections. Subscribes to Dawn's
   cartUpdate pub/sub and reads the authoritative count from /cart.js. */
(function () {
  'use strict';
  function paint(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var badge = document.getElementById('cpfs-cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.id = 'cpfs-cart-count';
        badge.className = 'v3-header__cart-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : count;
      link.classList.add('has-items');
    } else if (badge) {
      badge.remove();
      link.classList.remove('has-items');
    }
  }
  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        if (c && typeof c.item_count === 'number') paint(c.item_count);
      })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  });
})();
